import { render, staticRenderFns } from "./Client_history.vue?vue&type=template&id=5102792a"
import script from "./Client_history.vue?vue&type=script&lang=js"
export * from "./Client_history.vue?vue&type=script&lang=js"
import style0 from "./Client_history.vue?vue&type=style&index=0&id=5102792a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports